import { fromJS } from 'immutable';

import {
  LOADING_UNIVERSE,
  LOADED_UNIVERSE_SUCCESS,
  LOADED_SORTED_UNIVERSE_SUCCESS,
  RELOADED_UNIVERSE_SUCCESS,
  RELOADING_UNIVERSE,
} from '../../actions/eproject/universe';
import { spy } from '../../utils/ChangeSpy';

const defaultState = fromJS({ data: [], pagination: {} });

export default function(state = defaultState, action) {
  switch (action.type) {
    case LOADED_UNIVERSE_SUCCESS:
      return getUniverse(state, action.response);

    case RELOADED_UNIVERSE_SUCCESS:
      return getUniverse(state, action.response, true);

    case RELOADING_UNIVERSE:

    // fallthrough
    case LOADING_UNIVERSE:
      return state;

    case LOADED_SORTED_UNIVERSE_SUCCESS:
      return getSortedTargets(state, action.response);

    default:
      return state;
  }
}

/**
 * Get targets from response.
 *
 * @param state {Object} Current state.
 * @param response {Object} Response.
 * @param isReload {Boolean} If false concat data, for lazy loading.
 * @return {Immutable.List}
 */
function getUniverse(state, response, isReload = false) {
  if (response.status === 'success') {
    if (isReload) {
      return fromJS({
        data: response.data,
        pagination: response.meta.pagination,
      });
    }

    return fromJS({
      data: state
        .get('data')
        .toJS()
        .concat(response.data),
      pagination: response.meta.pagination,
    });
  }

  return defaultState;
}

/**
 * Get sorted targets from response.
 *
 * @param state {Object} Current state.
 * @param response {Object} Response.
 */
function getSortedTargets(state, response) {
  if (response.status === 'success') {
    return fromJS({
      data: response.data.map(t =>
        spy(
          {
            ...t,
            id: t.id,
            curr: t.currentStatus,
            high: t.highStatus,
            target: t.legalName,
            appList: t.applistLabel,
            priority: t.priority,
            approved: t.approved === '' ? null : t.approved,
            revenue: t.revenue,
            employees: t.employees,
            ebitda: t.ebitda,
            city: t.city,
            state: t.state,
            web: t.web,
            harvcoLead: t.harvcoLead,
            processing: false,
          },
          ['priority', 'approved'],
        ),
      ),
      pagination: state.get('pagination'),
    });
  }

  return defaultState;
}
